import type { PlanQueueQuery, PlanQueueSort, PlanQueueView } from '../../types/learning-plans';

const views: PlanQueueView[] = ['needs_setup', 'held', 'paid', 'closed', 'hold_ending', 'needs_lessons'];
const sorts: PlanQueueSort[] = ['newest', 'oldest', 'student', 'hold_deadline'];

export function planQueueState(params: URLSearchParams): PlanQueueQuery {
  const page = Number(params.get('page') ?? 1);
  const limit = Number(params.get('limit') ?? 20);
  const studentId = params.get('studentId') ?? '';
  return {
    page: Number.isSafeInteger(page) && page > 0 && page <= 1000000 ? page : 1,
    limit: [20, 50, 100].includes(limit) ? limit : 20,
    q: params.get('q')?.slice(0, 120) || undefined,
    studentId: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(studentId) ? studentId : undefined,
    status: views.find((view) => view === params.get('status')),
    sort: sorts.find((sort) => sort === params.get('sort')) ?? 'newest',
  };
}

export function updatePlanQueueState(params: URLSearchParams, key: 'q' | 'status' | 'sort' | 'page' | 'limit', value: string): URLSearchParams {
  const next = new URLSearchParams(params);
  if (value && !(key === 'page' && value === '1')) next.set(key, value);
  else next.delete(key);
  if (key !== 'page') next.delete('page');
  return next;
}
